module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Group chat setup","includeHistory":"Include conversation history for conferenced participants?","buttons":{"start":"Start group chat","cancel":"Cancel"}},"es":{"title":"Configuración de chat grupal","includeHistory":"Incluir el historial de la conversación para los nuevos participantes de la conferencia?","buttons":{"start":"Empezar chat grupal","cancel":"Cancelar"}}}')
  delete Component.options._Ctor
}
